module.exports = __webpack_public_path__ + "static/media/silver.b30545ab.png";